import { Vehicle } from "../../../../../types/appTypes";
import calculateRegistrationFee from "../../calc/registrationFeeDecorator";

export const PROFIT_MARGIN_RATE = 1.09;
export const VAT_RATE = 1.25;
export function calcTaxableValueFromPurchasePrice(purchasePrice: number | null) {
  if (purchasePrice == null) {
    return {
      purchasePrice: null,
      profitMargin: null,
      vatValue: null,
      taxableValue: null,
    }
  }

  const profitMargin = (purchasePrice * PROFIT_MARGIN_RATE) - purchasePrice;
  const vatValue = (purchasePrice * PROFIT_MARGIN_RATE * VAT_RATE) - purchasePrice * PROFIT_MARGIN_RATE;
  const taxableValue = purchasePrice * PROFIT_MARGIN_RATE * VAT_RATE;

  return {
    purchasePrice: purchasePrice,
    profitMargin: profitMargin,
    vatValue: vatValue,
    taxableValue,
  }
}

export async function calcTaxableValueFromSalesPrice(salesPrice: number | null, vehicle: Vehicle | null) {
  if (salesPrice == null) {
    return {
      salesPrice: null,
      registrationFee: null,
      taxableValue: null,
    }
  }

  const registrationFee = await calculateRegistrationFee({
    emissionAmount: vehicle?.emissionAmount,
    tradePrice: salesPrice,
    newPrice: salesPrice,
    isNew: false,
    batteryCapacity: vehicle?.batteryCapacity,
    electricConsumption: vehicle?.electricConsumption,
    electricRange: vehicle?.electricRange,
    emissionUnitId: vehicle?.emissionUnitId,
    firstRegDate: vehicle?.firstRegDate,
    isHighWeight: vehicle?.isHighWeight ?? false,
    // taxablePrice,
    vehicleTypeId: vehicle?.typeId,
    versionYear: new Date().getFullYear()
  })
  const taxableValue = salesPrice - (registrationFee.registrationFee ?? 0)

  return {
    salesPrice,
    registrationFee: registrationFee.registrationFee,
    taxableValue: taxableValue,
  }

}
